module.exports = __webpack_public_path__ + "img/invigorate-multiple-small.0e4b93ca.png";